<template>
    <div>
        <div class="innerMainContent">
            <div class="innerHeader">
                <div class="h1Wrap">
                    <svg class="i_calender"><use xlink:href="#i_calender"></use></svg>
                    <div class="innerH1Wrap">
                        <h1>{{ $t('eventEdit') }}</h1>
                        <ul class="breadcrumb">
                            <li><router-link to="/">{{ $t('menu_hp') }}</router-link></li>
                            <li><router-link v-bind:to="'/event/wedding/'+event.id">{{ $t('event') }}</router-link></li>
                            <li class="active">{{ $t('eventEdit') }}</li>
                        </ul>
                    </div>
                </div>
                <div class="editEventActions">
                    <button class="sendLoginDetails" @click="sendLoginDetails()" v-if="$store.state.user.type === 2">
                        <span>{{ $t('sendLoginDetails') }}</span>
                    </button>
                    <button class="backBtn" @click="this.$parent.goBack">
                        <span>{{ $t('back') }}</span>
                        <svg class="i_back"><use xlink:href="#i_longArr"></use></svg>
                    </button>
                </div>
            </div>
            <div class="innerBox">
                <form @submit.prevent="updateEvent" class="formWrap">
                    <div class="row">
                        <div class="col-xs-12 containerWidth">
                            <div class="row">
                                <div class="col-xs-12">
                                    <h2>{{ $t('eventOwnerDetails') }}</h2>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="ownerName_1">*{{ $t('eventOwnerName') }} <span>({{ $t('fullName') }})</span></label>
                                        <input type="text" id="ownerName_1" name="ownerName_1" v-model="event.owner.name" required>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="ownerEmail_1">*{{ $t('email') }}</label>
                                        <input type="email" id="ownerEmail_1" name="ownerEmail_1" v-model="event.owner.email" required>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="ownerPhone_1">*{{ $t('phone') }} <span>({{ $t('mobile') }})</span></label>
                                        <input type="tel" id="ownerPhone_1" name="ownerPhone_1" v-model="event.owner.phone" required>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="newPass">{{ $t('resetUserPassword') }}</label>
                                        <password :badge="false" :secureLength="6" :required="false" :placeholder="null" id="newPass" name="newPass" v-model="password"></password>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <br>
                            <div class="row">
                                <div class="col-xs-12">
                                    <h2>{{ $t('eventDetails') }}</h2>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="eventName_1">*{{ $t('eventName') }}</label>
                                        <input type="text" id="eventName_1" name="eventName_1" v-model="event.name" required>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="eventType_1">*{{ $t('eventType') }}</label>
                                        <div class="selectWrap">
                                            <select name="eventType_1" id="eventType_1" v-model="event.type.id" required>
                                                <option v-for="eventType in eventTypes" v-bind:value="eventType.id" v-bind:selected="(eventType.id == event.type.id ? 'selected' : '')">{{ eventType.title }}</option>
                                            </select>
                                            <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="eventHallName_1">*{{ $t('hall') }}</label>
                                        <div class="selectWrap">
                                            <select name="eventHallName_1" v-model="event.hall.id" id="eventHallName_1" required>
                                                <option v-for="hall in halls" v-bind:value="hall.id" v-bind:selected="(hall.id == event.hall.id ? 'selected' : '')">{{ hall.name }}</option>
                                            </select>
                                            <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="inputWrap dateWrap">
                                        <label for="eventDate_1">*{{ $t('eventDate') }}</label>
                                        <date-picker v-model="event.date" :config="datePickerConfig" required="true" id="eventDate_1"></date-picker>
                                        <svg class="i_calender datePickerIcon"><use xlink:href="#i_calender"></use></svg>

                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="eventGuestsNum_1">*{{ $t('guestsNum') }}</label>
                                        <input type="number" min="1" v-model="event.guests" id="eventGuestsNum_1" name="eventGuestsNum_1" required>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="eventGuestsNum_2">{{ $t('guestsSeatingLimit') }}</label>
                                        <input type="number" min="0" v-model="event.guestsSeatingLimit" id="eventGuestsNum_2" name="eventGuestsNum_2">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6 col-xs-12">
                                    <div class="">
                                        <label style="margin-right: 10px">{{
                                            $t('showTimerTxt') }}<input type="checkbox"
                                                                        v-model="event.showTimer"
                                                                        :checked="event.showTimer"
                                                                        value="true"
                                                                        style="-webkit-appearance: checkbox;appearance:checkbox"></label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12">
                                    <div class="inputWrap textareaWrap">
                                        <label for="eventNotes_1">{{ $t('notes') }}</label>
                                        <textarea name="eventNotes_1" v-model="event.notes" maxlength="200" id="eventNotes_1" class="noteWrapper"></textarea>
                                        <span class="charsLength"><span class="charNum">200</span>/200</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6 pull-left">
                                    <div class="inputWrap submitWrap">
                                        <button class="submit">{{ $t('saveEvent') }}</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import Password from 'vue-password-strength-meter'

    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';

    import moment from 'moment'
    export default {
        name: 'EventEdit',
        data() {
            return {
                halls:[],
                eventTypes:[],
                event:{owner:{},type:{},hall:{},guestsSeatingLimit:0,showTimer:false},
                clientName:'',
                password:'',
                datePickerConfig:{
                    format: 'DD/MM/YYYY HH:mm',
                    useCurrent: true,
                    sideBySide:true,
                    locale:this.$store.state.preferences.lang
                }
            }
        },
        components:{
            Password,
            datePicker
        },
        mounted(){

        },

        beforeMount(){
            if(this.$store.state.user.type != 2) this.$router.push('/');

            if(this.$data.halls.length == 0) {
                this.$store.dispatch('getDashboardData')
                    .then(response => {
                        //on success
                        this.$data.halls = this.$store.state.halls;
                        this.$data.eventTypes = this.$store.state.eventTypes;
                    })
                    .catch(response => {
                        //on err
                        console.warn('failed to fetch dash data')
                    })
            }else{
                this.$data.halls = this.$store.state.halls;
                this.$data.eventTypes = this.$store.state.eventTypes;
            }
            //get event
            this.$store.dispatch('getEvent',this.$router.currentRoute.params.id)
                                .then(response => {
                                    //on success
                                    if(response.data.admin.id != this.$store.state.user.id) {
                                        this.$router.push('/');
                                    }else{
                                        response.data.dateStr = moment.unix(response.data.date-10800).format("DD/MM/YYYY");
                                        this.$data.event = response.data;
                                        this.$data.event.date = moment.unix(this.$data.event.date-10800).toDate()
                                        document.title += ' :: ' + this.$data.event.name;
                                    }
                                })
                                .catch(response => {
                                    //on err
                                    this.$router.go('/');
                                });

        },
        methods:{
            openExistingClientSelector(){
                $("#modal-choose-client").iziModal({
                    autoOpen: 1,
                });
            },

            setClient(id){
                this.$data.client = id;
                this.$store.dispatch('getUser',id)
                    .then(response => {
                        //on success
                        this.$data.clientName = response.data.name;
                    })
            },

            updateEvent(){
                let o = this.$data.event;
                if(this.password != '') o.newUserPass = this.password;

                this.$store.dispatch('updateEvent',o)
                    .then(event => {
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'success',
                            title:this.$t('eventUpdated'),
                            timer:2000
                        })
                        this.$router.push('/events/' + o.id);
                    })
                    .catch(response => {
                        //on err
                        let err = this.$t('fatalError');
                        switch(response.code){
                            case -13:
                                err = this.$t('emailExist');
                                break;

                            case -12:
                                err = this.$t('fieldRequired_' + response.data.field);
                                break;

                            case -16:
                                err = this.$t('passwordsNotMatching');
                                break;

                            case -17:
                                err = this.$t('incorrectPassword');
                                break;
                        }
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:err,
                            timer:3000
                        }).catch(this.$swal.noop);
                    })
            },

            sendLoginDetails(){
                this.$store.dispatch('updateEvent',Object.assign(this.$data.event,{sendLoginDetails:true}))
                                        .then(response =>{
                                            //success
                                            this.$swal({
                                                confirmButtonText:this.$t('okButton'),
                                                type:'success',
                                                title:this.$t('loginDetailsSent'),
                                                timer:3000
                                            }).catch(this.$swal.noop);
                                        })
                                        .catch(err => {
                                            //err
                                            this.$swal({
                                                confirmButtonText:this.$t('okButton'),
                                                type:'error',
                                                title:this.$t('fatalError'),
                                                timer:3000
                                            }).catch(this.$swal.noop);
                                        })
            }
        }
    }

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .innerMainContent{
        padding:55px 45px;
        float: right;
        width:100%;
    }

    .editEventActions{
        float:left;
        margin-top: 6px;
    }
    .editEventActions .backBtn span{
        color:#7c97c5;
        font-weight:700;
        font-size:1.235rem;
        display:inline-block;
        vertical-align:middle;
    }
    .editEventActions .backBtn svg{
        display:inline-block;
        vertical-align:middle;
        width:26px;
        height:18px;
        fill:#293b5a;
        margin-right:5px;
    }
    .editEventActions .deleteBtn{
        width:218px;
        height:54px;
        background: #fff;
        border:1px solid #d4d4d4;
        border-radius:27px;
        margin-left:30px;

    }
    .editEventActions .deleteBtn span{
        color:#293b5a;
        font-weight:700;
        font-size:1rem;
        display:inline-block;
        vertical-align:middle;
    }
    .editEventActions .deleteBtn svg{
        display:inline-block;
        vertical-align:middle;
        width:19px;
        height:23px;
        fill:#849dc8;
        margin-left:10px;
    }
    .innerBox{
        padding:30px;
    }
    .h1Wrap svg.i_profile{
        width:26px;
        height:30px;
    }
    .sendLoginDetails{
        margin-left: 10px;
        width: 230px;
        height: 42px;
        border: 1px solid #52dbcd;
        border-radius: 21px;
        color:#fff;
        font-weight: bold;
        background: -moz-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* ff3.6+ */
        background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(41, 59, 90, 1)), color-stop(100%, rgba(123, 150, 196, 1)));
        /* safari4+,chrome */
        background: -webkit-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* safari5.1+,chrome10+ */
        background: -o-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* opera 11.10+ */
        background: -ms-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* ie10+ */
        background: linear-gradient(90deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* w3c */
        filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#293b5a', endColorstr='#7b96c4', GradientType=1 );
        /* ie6-9 */
    }
</style>
